<template>
    <div class="grid grid-cols-6 gap-6">

        <div class="col-span-6">
            <label for="soportePDF" class="block text-sm font-medium text-gray-700">Soporte CAP</label>
            <input
            type="file"
            name ="soportePDF"
            id="soportePDF"
            accept=".pdf"
            @change="handlePDFUpload();
            documentoSoporte=document.getElementById('soportePDF').files.item(0);"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
            <p class="mt-1 text-xs text-gray-500">Tamaño máximo permitido del archivo adjunto: 10MB (formato PDF).</p>
            <p v-if="selectedData.soportePDF">Archivo adjunto: {{ selectedData.soportePDF }}</p>
        </div>

        <div class="col-span-6 flex justify-center">
            <button @click=" customSaveData(documentoSoporte)" class="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
            </svg>
            <span class="ml-3">Guardar</span>
            </button>

            <button @click="handleBack" class="px-4 py-2 text-white bg-green-500 ml-3 rounded-md hover:bg-green-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11 19l-7-7 7-7"></path>
            </svg>
            <span class="ml-3">Volver</span>
            </button>
        </div>    
        
        <slot></slot>

      </div>
  </template>
  
  <script>
import {swal, useAPIRest} from "@/common/constants";
import { ref } from "vue";
import {saveUpdateData} from "@/layouts/main";
import { v4 as uuidv4 } from 'uuid';
  export default {
    name: 'CargueSoporteCAPComponent',
    props: ['view', 'paginate', 'selectedData','data','loadData', 'entity',
    'collectionTipoCAP','customUpdateLoadData','customUpdateValueData', 
    'customCreateActions',"dataCap"],
    emits: ["updateValues", "customSaveData","cargueSoporte"],
    data() {
      return {
        pasivoExigible:'',
        tipoCap: '',
        numeroCAP: '',
        fechaExpedicion: '',
        valorCAP: '',
        soportePDF:'',
        document: document
      };
    },
    setup(props) {
      console.log('dataCap',props.dataCap);
      const fetchData = async () => {
        const id = props.selectedData.id;
        console.log(id);
        try {
          const apiUrl = `${process.env.VUE_APP_NEST_CAP_CONSULTAPASIVO}/${id}`;
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${props.authToken}`,
            },
          });

          if (!response.ok) {
            throw new Error(`Error al obtener datos: ${response.statusText}`);
          }
          const data = await response.json();
          collectionData.value = [data];
          collectionData.value = data.map(cap => ({ ...cap, soporteCaps: [] }));
        } catch (error) {
          console.error(error);
        }
      };

      const openSoporte = async (url) => {
        const res = await useAPIRest(process.env.VUE_APP_NEST_SOPORTE_CAP_OBTENERARCHIVO + '?url=' + url, 
                        'GET', props.authToken)
        const blob = await res.blob()
        const filename = url.substring(url.lastIndexOf('/') + 1);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename || 'downloaded_file';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }   
      fetchData();
  
        return {
          collectionData,
          openSoporte
        }; 
    },
    methods: {
      async handlePDFUpload() {
        console.log('Cargando Archivo');
      },
      handleBack() {
          this.$emit('updateValues', { 'view': 'ver_caps' });
      },

      async customSaveData(documentoSoporte) {
        console.log('dataCap', this.$props.dataCap);
        documentoSoporte=document.getElementById('soportePDF').files.item(0);
        const uniqueFilename = `${uuidv4()}-${documentoSoporte.name}`;
        const url = `src/assets/documentos_soporte_pasivos_exigibles/soportes_cap/${uniqueFilename}`;
        const soporte_asociado_cap = {
          id_cap: this.$props.dataCap,
          url_archivo: url,
        };
        console.log(soporte_asociado_cap);
        try {
          const listApi = {
            create: process.env.VUE_APP_NEST_SOPORTE_ASOCIADO_CAP_CREATE
          };
         
          const resJSON = await saveUpdateData({
            listApi,
            authTnoken: this.authToken,
            loadData: soporte_asociado_cap,
            action: 'crear',
            entity: this.entity,
          }, undefined, false, false);

          console.log(resJSON);
          await this.cargueSoporte(uniqueFilename);
        }catch (error) {
          console.error('Error al guardar:', error);
        }
      },

      async cargueSoporte(uniqueFilename){
        let documentoSoporte=document.getElementById('soportePDF').files.item(0);
        const newLoadData = new FormData();
        // const uniqueFilename = `${uuidv4()}-${documentoSoporte.name}`;
        newLoadData.append('form', JSON.stringify({ uniqueFilename }));
        console.log(documentoSoporte)
        if (documentoSoporte) {
          const pesoMaximo = 10 * 1024 * 1024;
          if (documentoSoporte.size > pesoMaximo) {
            documentoSoporte = undefined;
            await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
          } else
            newLoadData.append('file', documentoSoporte, uniqueFilename);
        }
        console.log(process.env.VUE_APP_NEST_SOPORTE_ASOCIADO_CAP_CARGARARCHIVO)
          let resJSONSoporte = await useAPIRest(
            process.env.VUE_APP_NEST_SOPORTE_ASOCIADO_CAP_CARGARARCHIVO,
            'POST',
            this.authToken,
            newLoadData,
            undefined,'auto')
          console.log(resJSONSoporte);
          this.$emit('updateValues', { 'view': 'ver_caps' });
        },
      },
  };

    const collectionData = ref([]);

  </script>
